'use client';

import { type PropsWithChildren } from 'react';

import { HomeLayout } from '@/modules/home/HomeLayout';

const NewsLayout = ({ children }: PropsWithChildren) => {
  return <HomeLayout>{children}</HomeLayout>;
};

export default NewsLayout;
